import { CL_COUNTRY } from "@/apps/credit-line/types/cl_countries";
import { Service } from "@/apps/credit-line/services/network.service";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import { getCookieHelper } from "@/shared-helpers/get-cookie.helper";
import { setCookie } from "@/shared-helpers/set-cookie.helper";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { LogType } from "@/types/dataDogLogType";
import { getCurrentInstance } from "vue";
import { loadMultipleAppTranslations } from "@/i18n/translationLoader";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
export const setLanguage = async (context: any): Promise<void> => {
  try {
    const deviceLanguage = await getDeviceLanguage();

    // Set the locale FIRST so loadAppTranslations can read it
    context.$i18n.locale = deviceLanguage;

    // Load translations for the NEW locale
    await loadMultipleAppTranslations(["credit-line", "shared"]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    const instance = getCurrentInstance();
    if (!context || !context?.$i18n) {
      if (instance && instance.proxy && instance.proxy.$i18n) {
        instance.proxy.$i18n.locale = `${getLanguageName()}_MX`;
      }
    } else {
      context.$i18n.locale = `${getLanguageName()}_MX`;
    }
    DatadogLogger.Log(
      "error while setting the language --> " + e.message,
      e,
      LogType.ERROR
    );
  }
};

export const getCountry = async (): Promise<CL_COUNTRY> => {
  const apiService: Service = new Service();

  try {
    const cookieCountry: CL_COUNTRY | undefined = getCookieHelper("country") as
      | CL_COUNTRY
      | undefined;
    if (typeof cookieCountry !== "undefined") {
      return cookieCountry;
    }

    const res = await apiService.getCountry({
      deviceTag: AuthenticationHelper.getDeviceTag(),
    });
    const country = res.data.country;
    setCookie("country", country);
    return country as CL_COUNTRY;
  } catch (e) {
    DatadogLogger.Log(
      "error while getting country --> " + e.message,
      e,
      LogType.ERROR
    );
    return CL_COUNTRY.MX;
  }
};

export const getDeviceLanguage = async (): Promise<string> => {
  try {
    const country = await getCountry();

    if (country === CL_COUNTRY.US) {
      return "en_US";
    }

    // For all Spanish-speaking countries, return es_{COUNTRY}
    return `es_${country}`;
  } catch (e) {
    DatadogLogger.Log(
      "error while getting device language --> " + (e?.message ?? e),
      e,
      LogType.ERROR
    );
    return `${getLanguageName()}_MX`;
  }
};

export const getLanguage = (): string => {
  const userLang = window.navigator.language;
  if (typeof localStorage?.getItem === "function") {
    return (
      userLang.replace("-", "_") || localStorage.getItem("lang") || "es_MX"
    );
  }
  return "es_MX";
};

/**
 * To get just the language, example "en"
 * @returns string
 */
export const getLanguageName = (): string => getLanguage().substring(0, 2);
